<div class="cash-in-container d-flex flex-column justify-content-between p-4">
    <div class="header">
        <div class="d-flex justify-content-start align-items-center p-0" (click)="dialogRef.close()">
            <mat-icon class="header-control-icon">arrow_back</mat-icon>
            <span>Back</span>
        </div>
        
        <div class="header-sub-title">Scan the QR code or enter the code to proceed</div>
    </div>

    <div class="body my-5">
        <div class="camera-container d-md-flex flex-column align-items-center p-3">
            <img src="./assets/qr-code.svg" class="my-4" />
            <div class="camera-container-title">Scan QR Code</div>
            <div class="camera-container-sub-title mb-5">Open your camera to scan the qr code from the customer</div>
            <button (click)="openCamera()" mat-raised-button class="btn btn-secondary rounded-pill mb-3">
                <mat-icon class="camera-container-btn-icon">photo_camera</mat-icon>
                Open Camera
            </button>
        </div>

        <div class="input-container mt-4">
            <div class="input-container-title">Can’t scan the QR Code? Enter the code instead</div>
            <div class="input-container-input">
                <app-value-field [editMode]="true">
                    <app-value-field-input *ngIf="code" [controlDisplayName]="'Code'" [control]="code" appValueField="editField" />
                </app-value-field>
                <div class="error-message" *ngIf="codeFailed">
                    <mat-icon class="error-message-icon">error-icon-danger</mat-icon>
                    <span>Code expired. Please try again</span>
                </div>
            </div>
        </div>
    </div>

    <div class="footer mb-2">
        <hr />
        <button
            (click)="onContinue()"
            mat-raised-button
            class="btn-primary rounded-pill mx-2"
            [class.btn-primary-disabled]="code.invalid || !code.dirty"
            [class.button-spinner]="loading"
            [disabled]="code.invalid || !code.dirty || loading"
        >
            {{ loading ? '' : 'Continue' }}
        </button>
    </div>
</div>
